module.exports = __webpack_public_path__ + "assets/img/Facebook-white.29afeb98.svg";